var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7683 26.7767C48.7683 24.376 50.7473 22.4377 53.1628 22.5039C55.491 22.5677 57.3172 24.5365 57.3172 26.8655V40.3235C57.3172 52.0974 47.7724 61.6422 35.9984 61.6422C24.2245 61.6422 14.6797 52.0974 14.6797 40.3235V33.7003C14.6797 31.3703 16.5684 29.4816 18.8984 29.4816C21.2285 29.4816 23.1172 31.3703 23.1172 33.7003V41.9182V17.8228C23.1172 15.4222 25.0962 13.4838 27.5117 13.55C29.8399 13.6139 31.6661 15.5826 31.6661 17.9117V35.3184V15.0103C31.6661 12.6496 33.5798 10.7358 35.9405 10.7358C38.3012 10.7358 40.2149 12.6496 40.2149 15.0103L40.2197 35.3184V17.8228C40.2197 15.4222 42.1987 13.4838 44.6143 13.55C46.9424 13.6139 48.7686 15.5826 48.7686 17.9117V35.3184",
    stroke: "#F30002",
    strokeWidth: 4.21875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0379 2.29834H21.9621L2.10938 22.1511V50.2269L21.9621 70.0796H50.0379L69.8906 50.2269V22.1511L50.0379 2.29834Z",
    stroke: "#161614",
    strokeWidth: 4.21875,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.188965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.2cf49d4b67537c4202785be1e5a8df64.svg";
export { ForwardRef as ReactComponent };